
import { Injectable } from '@angular/core';

@Injectable()
export class DBkeys {

    public static readonly CURRENT_USER = '__iqgcs';
    public static readonly USER_PERMISSIONS = '__iqgupts';
    public static readonly USER_ROLES = '__iqgur';
    public static readonly USER_TENANT_MAP = '__iq4gutm';
    public static readonly USER_CURRENT_TENANT = '__iqgct';
    public static readonly ACCESS_TOKEN = '__iqgat';
    public static readonly ID_TOKEN = 'id_token';
    public static readonly REFRESH_TOKEN = '__iqgrt';
    public static readonly TOKEN_EXPIRES_IN = '__iqgtei';
    public static readonly HAS_USER_IND_Access = '__iqiqa';

    public static readonly REMEMBER_ME = 'remember_me';

    public static readonly LANGUAGE = 'language';
    public static readonly MARKET = 'market';
    public static readonly HOME_URL = 'home_url';
    public static readonly THEME = 'theme';
    public static readonly SHOW_DASHBOARD_STATISTICS = 'show_dashboard_statistics';
    public static readonly SHOW_DASHBOARD_NOTIFICATIONS = 'show_dashboard_notifications';
    public static readonly SHOW_DASHBOARD_TODO = 'show_dashboard_todo';
    public static readonly SHOW_DASHBOARD_BANNER = 'show_dashboard_banner';
}
